import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { ResponseStatus, buildQueryParams } from '../helpers';
import { initWebApi } from '../services/web-api';
export function useSliderData({
  environment,
  webAPIKey,
  limit,
  offset,
  language,
  order,
  sort,
  filterOptions,
  fetchFunction
}) {
  const [webApiIsInitialized, setWebApiIsInitialized] = useState(false);
  const [entities, setEntities] = useState([]);
  const [totalHits, setTotalHits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [responseStatus, setResponseStatus] = useState(ResponseStatus.ok);
  const {
    search,
    ids,
    region,
    fo,
    category,
    brand,
    label,
    additionalQueryParams,
    campaign_id,
    event_id,
    high_performer,
    is_variant,
    preferredIds
  } = filterOptions;
  useEffect(() => {
    const queryParams = buildQueryParams({
      search,
      ids,
      order,
      sort,
      region,
      fo,
      is_variant,
      category,
      brand,
      label,
      campaign_id,
      event_id,
      high_performer,
      language,
      additionalQueryParams,
      preferredIds
    });
    const fetchData = async (environment, webAPIKey, queryParams, limit, offset) => {
      setLoading(true);
      if (!webApiIsInitialized) {
        await initWebApi({
          environment,
          webAPIKey
        });
        setWebApiIsInitialized(true);
      }
      const fetchParams = _objectSpread(_objectSpread({}, queryParams), {}, {
        limit,
        offset
      });
      const {
        entities,
        totalHits,
        responseStatus
      } = await fetchFunction(fetchParams);
      if (entities && entities.length > 0) {
        setEntities(entities);
        if (totalHits) {
          setTotalHits(totalHits);
        }
      }
      if (responseStatus) {
        setResponseStatus(responseStatus);
      }
      setLoading(false);
    };
    fetchData(environment, webAPIKey, queryParams, limit, offset);
  }, [environment, webAPIKey, limit, offset, search, JSON.stringify(ids), order, sort, region, JSON.stringify(fo), is_variant, category, brand, label, campaign_id, event_id, high_performer, language, JSON.stringify(additionalQueryParams)]);
  return {
    entities,
    totalHits,
    loading,
    responseStatus
  };
}